<template>
    <!--deep Modal-->
    <div id="deepknow"  class="modal fade  deepknow" tabindex="-1" role="dialog" aria-labelledby="gridSystemModalLabel" style="margin-left: -15%">
        <div class="modal-dialog" role="document">
            <div class="modal-content ">
                <div class="modal-header">
                    <button type="button" class="close" data-dismiss="modal" aria-label="Close"><span aria-hidden="true" style="font-size: 20px">&times;</span></button>
                </div>
                <div class="modal-body">
                    <div>
                        <p class="dk_title" >
                            <span style="display:block;">ZEMCHO EI</span>
                            <span class="mr32">版本更新公告</span>

                            <em class="dk_itembox mr16"  v-if="this.firstlist[0]"><em class="em1">更新版本</em>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;<em class="em2">{{this.firstlist[0].subtitle}}</em></em>
                            <em class="dk_itembox"  v-if="this.firstlist[0]"> <em class="em1">更新时间</em>&nbsp;&nbsp;<em class="em2" >{{this.firstlist[0].time}}</em></em>

                        </p>

                    </div>

                    <div class="dk_main" v-if="list" >

                        <!--可年循环使用-->
                        <p class="time_year">{{list[0].itemName}}年</p>

                        <!--可用月日于循环使用-->
                        <div v-if="list.length > 0" class="timeBox" v-for="(item,i) in list[0].list" :key="i" >
                            <p class="time_day timepos" ><span>{{item.CNtime}}</span></p>
                            <div class="time_contextBox"  :style="{borderColor: (listFlag.length == 1 && i == list[0].list.length-1) ? '#fff' : '' }">
                                <span class="time_cicle " :style="{backgroundColor:i ==0 ? '#5182E4' : ''}"></span>
                                <div class="time_context" style="position: relative;">
                                    <p style="color:#5182E4;position:absolute;top:-6px;">{{item.subtitle}}</p>
                                    <p style="height: 6px;"></p>

                                    <div class="time_itemBox " >
                                         <div  v-html="item.content">

                                         </div>
                                        <!--<p>1. 更新内容一</p>-->
                                        <!--<span>段落示意：组件拖出来特别多一个一个删麻烦，这个问题，首先将组件拖入画布中，然后按住“shift”键，-->
                                           <!--用鼠标点击要使用的组件，使该组件取消选择。再点击“delete”键 ，即可删除剩余不需要使用的组件。</span>-->
                                        <!--<img src="../../public/static/images/img1.png" alt="">-->
                                    </div>

                                </div>


                            </div>
                        </div>

                        <!--<div class="timeBox">-->
                            <!--<p class="time_day">09月20日</p>-->
                            <!--<div class="time_contextBox">-->
                                <!--<span class="time_cicle "></span>-->

                                <!--&lt;!&ndash;可用于循环使用&ndash;&gt;-->
                                <!--<div class="time_context">-->
                                    <!--<p>V1.2.0</p>-->

                                    <!--<div class="time_itemBox ">-->
                                        <!--<p>1. 更新内容一</p>-->

                                        <!--<span>段落示意：组件拖出来特别多一个一个删麻烦，这个问题，首先将组件拖入画布中，然后按住“shift”键，-->
                                           <!--用鼠标点击要使用的组件，使该组件取消选择。再点击“delete”键 ，即可删除剩余不需要使用的组件。</span>-->

                                        <!--<img src="../../public/static/images/img1.png" alt="">-->

                                    <!--</div>-->

                                <!--</div>-->


                            <!--</div>-->
                        <!--</div>-->


                       <!--第二年-->
                        <div class="timeBox" v-for="(item,index) in list" :key="'key'+index" >
                            <div v-if="index > 0" v-for="(kitem,ki) in item.list" :key="'kid'+ki">
                              <p class="time_day"><span style="display: block;font-size: 20px;" class="timeother_pos">{{ki ==0 ? item.itemName+'年' : ''}}</span><em class="timedate_pos">{{kitem.CNtime}}</em></p>

                              <div class="time_contextBox" :style="{borderColor:ki == list[list.length-1].list.length-1 ? '#fff' : '' }">
                                <span class="time_cicle "></span>

                                <!--可用于循环使用-->
                                <div class="time_context"  style="position: relative;">
                                    <p style="color:#5182E4; position:absolute;top:-6px;">{{kitem.subtitle}}</p>
                                    <p style="height: 6px;"></p>
                                    <div class="time_itemBox " v-html="kitem.content">
                                        <!--<p>1. 更新内容一</p>-->
                                        <!--<span>段落示意：组件拖出来特别多一个一个删麻烦，这个问题，首先将组件拖入画布中，然后按住“shift”键，-->
                                           <!--用鼠标点击要使用的组件，使该组件取消选择。再点击“delete”键 ，即可删除剩余不需要使用的组件。</span>-->
                                        <!--<img src="../../public/static/images/img1.png" alt="">-->
                                    </div>

                                </div>

                               </div>

                            </div>
                        </div>

                    </div>




                </div>

            </div><!-- /.modal-content -->
        </div><!-- /.modal-dialog -->
    </div><!-- /.modal -->

</template>

<script>

    export default {
        name: "DeepModal",
        props:['updateChildren'],
        data(){
            return{
                list:[],
                firstlist:[],

                listFlag:[],  //是否所有目录里只有一个 版本更新数据


            }
        },
        created(){

            this.initdata();

        },
        methods:{
             initdata(){
                this.updateChildren && this.updateChildren.map((item,i)=>{
                    this.$GetCatalogueData({catalogueId:item.toUid})
                        .then(() => {
                            if(this.$store.state.catalogueData.articles.list.length ==0){
                                this.updateChildren.splice(i,1)
                            }else {


                            if(i == this.updateChildren.length-1){
                                const timearr =this.$store.state.catalogueData.articles.list[0].publishTime.split(' ')[0].replace(/-/g,'.');
                                let tmp = this.$store.state.catalogueData.articles.list[0] ;
                                tmp.time =timearr;
                                this.$set(this.firstlist,0,tmp);
                            }


                            // this.updateCatalogueData = this.$store.state.catalogueData;
                           // this.tmplist.push(this.$store.state.catalogueData.articles.list);
                           //  this.updateChildren[i].list=this.$store.state.catalogueData.articles.list;
                            this.listFlag.push(i);

                            this.$set(this.updateChildren[i],'list',this.$store.state.catalogueData.articles.list);
                            this.updateList = this.$store.state.catalogueData.articles.list;


                            this.updateList.map((kitem,ki)=>{

                                this.$GetArticleData({ articleId: kitem.articleId}).then(() => {
                                    // this.updateChildren[i].list[ki].content = this.$store.state.articleData.content;
                                    // console.log(i,ki,kitem.publishTime)
                                    const ktimearr =kitem.publishTime.split(' ')[0].split('-');
                                    const time =ktimearr[1]+'月'+ktimearr[2]+'日'
                                    this.$set(this.updateChildren[i].list[ki],'content',this.$store.state.articleData.content);
                                    this.$set(this.updateChildren[i].list[ki],'CNtime',time);
                                });

                            });

                                this.list.unshift(this.updateChildren[i]);

                            }
                        })



                })

                 // console.log(this.updateChildren);

                // this.updateChildren.map((item,i)=>{
                //     console.log(item,i)
                //    this.list.unshift(item);
                // })
               // console.log("all",this.list,this.firstlist,this.listFlag);


            }


        }

    }
</script>

<style scoped>

</style>